<template>
  <div :id>
    <div>{{ media?.id }}</div>
  </div>
</template>

<script lang="ts" setup>
import type { ParagraphVideoFragment } from '#build/graphql-operations'

defineProps<ParagraphVideoFragment>()

const { index, siblings } = defineBlokkli({
  bundle: 'video',
  globalOptions: ['isHero', 'bkHiddenGlobally', 'publicationChannels'],
})

const id = useParagraphAnchorId(index, siblings)
</script>
